import { ILayerObject } from '../types/layers';
import { leftpanel } from './leftpanel.config';

/* const stagingLayers: Array<ILayerObject> = [
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/FSC_Certified_Forests/FeatureServer',
      id: 'fsc-certified-forests',
      group: 'key-layers',
      subgroup: null,
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/c4d8d84335234cc183009dea61b32f9f?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'FSC Certified Forests',
      visible: true,
      includeInDropdowns: false,
      outFields: ['fsc_cert', 'globalid'],
      popupTemplate: {
        title: 'Certification number: {fsc_cert}',
        content: `
          <div>Certified Organization: {contributo}</div>
          <div>Certified area: {areaFSC_ha}</div>
          <div>Certificate: <a href={certificate} target='_blank'>{certificate}</a></div>
        `,
      },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Hansen_lossyear_2020/ImageServer',
      id: 'hansen',
      group: 'key-layers',
      subgroup: null,
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/3b4bc421828c4882ab7ffe52f97cdd26?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: `Tree Cover Loss (2001 - ${leftpanel.hansenEndYear})`,
      visible: false,
      renderingRule: {
        rasterFunction: 'Mask',
        rasterFunctionArguments: {
          NoDataValues: ['0'],
          IncludedRanges: [leftpanel.hansenEndYear - 2000 - 1, leftpanel.hansenEndYear - 2000],
          NoDataInterpretation: 0,
        },
      },
      includeInDropdowns: false,
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://services5.arcgis.com/Mj0hjvkNtV7NRhA7/arcgis/rest/services/WDPA_v1/FeatureServer/1',
      id: 'protected-areas',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/2799cc9ad9e34d41b799731c6b174e9c?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Protected Areas',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {ORIG_NAME}',
        content: `
          <div>Type of Designation: {DESIG_TYPE}</div>
          <div>Designation: {DESIG_ENG}</div>
          <div>Status: {STATUS}</div>
          <div>Status Year: {STATUS_YR}</div>
          <div>Governance Type: {GOV_TYPE}</div>
          <div>Management Authority: {MANAG_AUTH}</div>
        `,
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/Local_Community_Territories/FeatureServer/0',
      id: 'community-land-rights',
      group: 'analysis-layers',
      subgroup: 'human-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/489d8269be4945ae9f5e1f589650cb89?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Community Land Rights',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {name}',
        content: `
          <div>Identity: {Identity}</div>
          <div>Recognition: {form_Rec}</div>
          <div>Documentation: {Doc_Status}</div>
          <div>Ethnic groups: {Ethncty_1}</div>
          <div>Source: {Data_Src}</div>
          <div>Date: {Data_Date}</div>
          <div>More info: <a href={More_info} target='_blank'>{More_info}</a></div>
        `,
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/Indigenous_Community_Lands/FeatureServer/0',
      id: 'indigenous-land-rights',
      group: 'analysis-layers',
      subgroup: 'human-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/e809710f5eec4d8d98bc3dcb997cc4a4?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Indigenous Land Rights',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {name}',
        content: `
          <div>Identity: {Identity}</div>
          <div>Recognition: {form_Rec}</div>
          <div>Documentation: {Doc_Status}</div>
          <div>Ethnic groups: {Ethncty_1}</div>
          <div>Source: {Data_Src}</div>
          <div>Date: {Data_Date}</div>
          <div>More info: <a href={More_info} target='_blank'>{More_info}</a></div>
        `,
      },
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Intact_Forest_Landscapes/MapServer',
      id: 'intact-forest-landscape',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/cfa4227247894cc89903f84084eb6469?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Intact Forest Landscapes',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'IFL: {IFL_ID}',
            content: ''
          }
        }
      ]
    },
  },
  {
    type: 'TileLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Global_Hydrography_Feet/MapServer',
      id: 'hydrology',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/7561a76b36564ce6b0e41badf6bcf853?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Hydrology',
      visible: false,
      includeInDropdowns: false,
      optionalQueryLayer: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/Optimized_Hydro/FeatureServer/0',
    },
  },
  {
    type: 'TileLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Plantations_World_Historic/MapServer',
      id: 'historical-plantations',
      group: 'analysis-layers',
      subgroup: 'human-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/495b0672661847beb86f07f90cc74ed8?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Historical Plantations',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '',
        content: `
          <div>Species: {species_simp}</div>
          <div>Name: {common_name}</div>
          <div>Planted: {plant_ag}</div>
          <div>Data Source: {source}</div>
          <div>Source Date: {year}</div>
        `,
      },
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Centres_Plant_Diversity/MapServer',
      id: 'centres-of-plant-diversity',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/b19c316b6d1b4bb982cb411fa8126387?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Centres of Plant Diversity',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'Area Name: {AREANAME}',
            content: '',
          },
        }
      ]
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/RegArchaeologicalSites/FeatureServer/0',
      id: 'archeological-sites-brazil',
      group: 'reference-layers',
      subgroup: null,
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/5b234e533b9f42e68fe12d11530d6f7a?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Archeological Sites (Brazil)',
      visible: false,
      includeInDropdowns: false,
      popupTemplate: {
        title: 'Site: {nome}',
        content: '',
      },
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Biodiversity_Conservation_Areas/MapServer',
      id: 'priority-areas-for-biodiversity-conservation-brazil',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/28376190f9fb4c2ba5696a7fb49b8b1e?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Priority Areas for Biodiversity Conservation (Brazil)',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'COD: {COD_area}',
            content: '',
          },
        }
      ]
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Hosted/Russian_IBAs_2014_RBCUdata/FeatureServer',
      id: 'important-bird-areas-russia',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/75f505c0de1b41b69265640bdc440505?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Important Bird Areas (Russia)',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Area Name: {Int_Name}',
        content: `
          <div>Year: {VerifYear}</div>
        `,
      },
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Ramsar/MapServer',
      id: 'ramsar',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/eb91fc2968d04a859d1ec74eced94ede?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Ramsar',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'Area Name: {officialna}',
            content: `
              <div>Country: {country_en}</div>
            `,
          },
        }
      ]
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://ec.gc.ca/arcgis/rest/services/SpeciesProtectRestore_Canada_CanadianWildlifeService/MapServer/1',
      id: 'boreal-woodland-caribou-canada',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/b8b819f6ec8a46c8bd049fbbba4af756?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Boreal Woodland Caribou (Canada)',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '{LABEL2}',
        content: '',
      },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/TCLDD_FinalClassification2/ImageServer',
      id: 'tree-cover-loss-by-dominant-driver',
      group: 'reference-layers',
      subgroup: null,
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/243a9a7420df4eec80cd9e256ccf010f?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Tree Cover Loss by Dominant Driver',
      visible: false,
      includeInDropdowns: false,
      renderingRule: { functionName: 'TCLDD_fuction1' },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://utility.arcgis.com/usrsvcs/servers/2c423a0011ed47b885af67564eb86862/rest/services/Sentinel2L2A/ImageServer',
      id: 'sentinel',
      group: 'imagery',
      subgroup: null,
      pixelType: 'u8',
      portalUrl: 'https://utility.arcgis.com/usrsvcs/servers/2c423a0011ed47b885af67564eb86862/rest/services/Sentinel2L2A/ImageServer?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Sentinel-2',
      visible: false,
      compressionQuality: 50,
      renderingRule: { rasterFunction: 'Natural Color with DRA' },
      includeInDropdowns: false,
      timeInfo: {
        startField: 'acquisitiondate',
      },
      useViewTime: false,
    },
    renderingRules: [
      'Agriculture with DRA',
      'Color Infrared with DRA',
      'Natural Color with DRA',
      'NDVI Colorized',
      'NDVI Colormap',
      'Normalized Difference Built-Up Index (NDBI)',
      'Geology with DRA',
      'Short-wave Infrared with DRA',
      'Normalized Burn Ratio',
      'NDVI - VRE only Raw',
    ],
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://utility.arcgis.com/usrsvcs/servers/3c96d8d1107940c682f787eeed847e93/rest/services/LandsatC2L2/ImageServer',
      id: 'landsat',
      group: 'imagery',
      subgroup: null,
      portalUrl: 'https://utility.arcgis.com/usrsvcs/servers/3c96d8d1107940c682f787eeed847e93/rest/services/LandsatC2L2/ImageServer?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Landsat 8',
      pixelType: 'u8',
      visible: false,
      compressionQuality: 50,
      renderingRule: { rasterFunction: 'Natural Color with DRA' },
      includeInDropdowns: false,
      timeInfo: {
        startField: 'acquisitiondate',
      },
      useViewTime: false,
    },
    renderingRules: [
      'Agriculture with DRA',
      'Color Infrared with DRA',
      'Geology with DRA',
      'Landsat8_TIRS1_Temperature_Celcius',
      'Natural Color with DRA',
      'Short-wave Infrared with DRA',
      'NDVI Colorized',
      'Normalized Difference Moisture Index Colorized',
      'NDVI Raw',
      'NBR Raw',
    ],
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://utility.arcgis.com/usrsvcs/servers/d7d5e3fcc4874e6eadfc47e3fd6dc1d0/rest/services/WorldElevation/Terrain/ImageServer',
      id: 'terrain',
      group: 'reference-layers',
      subgroup: null,
      portalUrl: 'https://fsc-int.maps.arcgis.com/sharing/rest/content/items/d7d5e3fcc4874e6eadfc47e3fd6dc1d0?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Terrain',
      visible: false,
      compressionQuality: 50,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'Elevation_Tinted_Hillshade' },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://landscape12.arcgis.com/arcgis/rest/services/World_Terrestrial_Ecosystems/ImageServer',
      id: 'world-terr-ecosys',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/c83f58136e2e480993a3ce9df3c95a15?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'World Terrestrial Ecosystems',
      visible: false,
      includeInDropdowns: true,
      // renderingRule: { rasterFunction: 'Elevation_Tinted_Hillshade' }, // THIS RENDERING RULE IS NOT POSSIBLE ON THIS LAYER
      popupTemplate: {
        title: 'Name: {Name}',
        content: `
          <div>Category: {Category}</div>
        `,
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/MODIS_Thermal_v1/FeatureServer',
      id: 'modis-fire-layer',
      group: 'reference-layers',
      subgroup: null,
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/1bd944dbd93b490cbe1f2614c5356516?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'MODIS Fires (Last 48 Hours)',
      visible: false,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'TCLDD_fuction1' },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://services.arcgis.com/nzS0F0zdNLvs7nc8/arcgis/rest/services/Terrestrial_biodiversity_hotspots/FeatureServer',
      id: 'world-terr-biodiver-hotspots',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl:
      'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/b53aac3b282a49db910bf992770da4ee?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'World Terrestrial Biodiversity Hotspots',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {NAME}',
        content: '',
      },
    },
  },
  {
    type: 'TileLayer',
    options: {
      url: 'https://devfscintmaps.fsc.org/server/rest/services/Natura_2000/MapServer',
      id: 'natura-2000',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/83c8aaa669264511ada994bf53161089?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Natura 2000',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '{SITENAME}',
        content: ''
      },
    },
  },
  {
    type: 'ImageryTileLayer',
    options: {
      url: 'https://tiledimageservices.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/Esri_2020_Land_Cover_V2/ImageServer',
      id: 'landcover-10-meter',
      group: 'reference-layers',
      subgroup: null,
      portalUrl:
        'https://devfscintmaps.fsc.org/portal/sharing/rest/content/items/1b512e9d8fc046a2a0bcd9c5675af6ee?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Landcover 10 Meter ',
      visible: false,
      compressionQuality: 50,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'Elevation_Tinted_Hillshade' },
      popupEnabled: true,
      popupTemplate: {
        title: '{Raster.ClassName}:',
        content: `
          <div>{Raster.desc1}</div>
          <div><i>{Raster.desc2}</i></div>
        `,
      },
    },
  },
]; */

const prodLayers: Array<ILayerObject> = [
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Hosted/IRI_FSC_ALL/FeatureServer/0',
      id: 'fsc-certified-forests',
      group: 'key-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/6d43e880b0314d5c977cab1a43f6b8cc?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'FSC Certified Forests',
      visible: true,
      includeInDropdowns: false,
      outFields: ['FSC_Cert', 'GlobalID'],
      popupTemplate: {
        title: 'Certification number: {FSC_Cert}',
        content: `
          <div>Certified Organization: {Contributo}</div>
          <div>Certified area: {areaFSC_ha}</div>
          <div>Certificate: <a href={certificate} target='_blank'>{certificate}</a></div>
        `,
      },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Hansen_lossyear_2020_v3/ImageServer',
      id: 'hansen',
      group: 'key-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/d207bf35a7d444feb4708262bf21f93d?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: `Tree Cover Loss (2001 - ${leftpanel.hansenEndYear})`,
      visible: false,
      renderingRule: {
        rasterFunction: 'Mask',
        rasterFunctionArguments: {
          NoDataValues: ['0'],
          IncludedRanges: [leftpanel.hansenEndYear - 2000 - 1, leftpanel.hansenEndYear - 2000],
          NoDataInterpretation: 0,
        },
      },
      includeInDropdowns: false,
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://services5.arcgis.com/Mj0hjvkNtV7NRhA7/arcgis/rest/services/WDPA_v1/FeatureServer/1',
      id: 'protected-areas',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/f7dfccd4e86f46da963c115be04c4072?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Protected Areas',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {ORIG_NAME}',
        content: `
          <div>Type of Designation: {DESIG_TYPE}</div>
          <div>Designation: {DESIG_ENG}</div>
          <div>Status: {STATUS}</div>
          <div>Status Year: {STATUS_YR}</div>
          <div>Governance Type: {GOV_TYPE}</div>
          <div>Management Authority: {MANAG_AUTH}</div>
        `,
      },
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/IFL_2016/MapServer',
      id: 'intact-forest-landscape',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/657035ee1623404c937af460b7bebd38?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Intact Forest Landscapes',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'IFL: {IFL_ID}',
            content: ''
          }
        }
      ]
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Ramsar/MapServer',
      id: 'ramsar',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/0ebe35e78a3f404ab6ca9a99071dacb0?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Ramsar',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'Area Name: {officialna}',
            content: `
              <div>Country: {country_en}</div>
            `,
          },
        }
      ]
    },
  },
  {
    type: 'TileLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Global_Hydrography/MapServer',
      id: 'hydrology',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/0feb6f38bbf345cbb06a79a06482c56b?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Hydrology',
      visible: false,
      includeInDropdowns: false,
      optionalQueryLayer: 'https://maps.fsc.org/server/rest/services/Hosted/Optimized_Hyrdo/FeatureServer/0',
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Centres_Plant_Diversity/MapServer',
      id: 'centres-of-plant-diversity',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/94493f191e1849ea8522b8971ef5a508?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Centres of Plant Diversity',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'Area Name: {AREANAME}',
            content: '',
          },
        }
      ]
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://landscape12.arcgis.com/arcgis/rest/services/World_Terrestrial_Ecosystems/ImageServer',
      id: 'world-terr-ecosys',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/5013412a7fec46b0addad70f52e81532?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'World Terrestrial Ecosystems',
      visible: false,
      includeInDropdowns: true,
      // renderingRule: { rasterFunction: 'Elevation_Tinted_Hillshade' }, // THIS RENDERING RULE IS NOT POSSIBLE ON THIS LAYER
      popupTemplate: {
        title: 'Name: {Name}',
        content: `
          <div>Category: {Category}</div>
        `,
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://services.arcgis.com/nzS0F0zdNLvs7nc8/arcgis/rest/services/Terrestrial_biodiversity_hotspots/FeatureServer',
      id: 'world-terr-biodiver-hotspots',
      group: 'analysis-layers',
      subgroup: 'global-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/2f6232a54012457286b05a7e0f1ab1c1?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'World Terrestrial Biodiversity Hotspots',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '{NAME}',
        content: '',
      },
    },
  },
  {
    type: 'MapImageLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Biodiversity_Conservation_Areas/MapServer',
      id: 'priority-areas-for-biodiversity-conservation-brazil',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/e19eaaca9eec4acb894e7d1cfa7faf70?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Priority Areas for Biodiversity Conservation (Brazil)',
      visible: false,
      includeInDropdowns: true,
      sublayers: [
        {
          id: 0,
          visible: true,
          popupTemplate: {
            title: 'COD: {COD_area}',
            content: '',
          },
        }
      ]
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://ec.gc.ca/arcgis/rest/services/SpeciesProtectRestore_Canada_CanadianWildlifeService/MapServer/1',
      id: 'boreal-woodland-caribou-canada',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/a3d69a4fcb884278a5c03b5cf26b3331?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Boreal Woodland Caribou (Canada)',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '{LABEL2}',
        content: '',
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Hosted/Russian_IBAs_2014/FeatureServer',
      id: 'important-bird-areas-russia',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/21a325614fdb462aabed33fc9f6ff7e6?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Important Bird Areas (Russia)',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Area Name: {Int_Name}',
        content: `
          <div>Year: {VerifYear}</div>
        `,
      },
    },
  },
  {
    type: 'TileLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Natura_2000/MapServer',
      id: 'natura-2000',
      group: 'analysis-layers',
      subgroup: 'regional-eco-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/5cb5414321814f469a7c0087432d3f6b?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Natura 2000',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '{SITENAME}',
        content: ''
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Hosted/Local_Community_Territories/FeatureServer',
      id: 'community-land-rights',
      group: 'analysis-layers',
      subgroup: 'human-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/2decb8f7fe8046139dec3313b3d93c72?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Community Land Rights',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {name}',
        content: `
          <div>Identity: {Identity}</div>
          <div>Recognition: {form_Rec}</div>
          <div>Documentation: {Doc_Status}</div>
          <div>Ethnic groups: {Ethncty_1}</div>
          <div>Source: {Data_Src}</div>
          <div>Date: {Data_Date}</div>
          <div>More info: <a href={More_info} target='_blank'>{More_info}</a></div>
        `,
      },
    },
  },
  {
    type: 'TileLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Historic_Global_Plantations/MapServer',
      id: 'historical-plantations',
      group: 'analysis-layers',
      subgroup: 'human-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/30741fcbabc644d08c03337855ceb174?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Historical Plantations',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: '',
        content: `
          <div>Species: {species_simp}</div>
          <div>Name: {common_name}</div>
          <div>Planted: {plant_ag}</div>
          <div>Data Source: {source}</div>
          <div>Source Date: {year}</div>
        `,
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Hosted/Indigenous_Territories/FeatureServer',
      id: 'indigenous-land-rights',
      group: 'analysis-layers',
      subgroup: 'human-layers',
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/df8131c0b9dc4c61a8caaba83532a562?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Indigenous Land Rights',
      visible: false,
      includeInDropdowns: true,
      popupTemplate: {
        title: 'Name: {name}',
        content: `
          <div>Identity: {Identity}</div>
          <div>Recognition: {form_Rec}</div>
          <div>Documentation: {Doc_Status}</div>
          <div>Ethnic groups: {Ethncty_1}</div>
          <div>Source: {Data_Src}</div>
          <div>Date: {Data_Date}</div>
          <div>More info: <a href={More_info} target='_blank'>{More_info}</a></div>
        `,
      },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/Hosted/RegArchaeologicalSites/FeatureServer',
      id: 'archeological-sites-brazil',
      group: 'reference-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/2cd687a11d384773b78928c5d267c7f7?f=pjson', // USED TO FETCH LAYER DESCRIPTION c4b7f7354eba496f86c99359dc8fb396
      title: 'Archeological Sites (Brazil)',
      visible: false,
      includeInDropdowns: false,
      popupTemplate: {
        title: 'Site: {nome}',
        content: '',
      },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://maps.fsc.org/server/rest/services/TCLDD_FinalClassification/ImageServer',
      id: 'tree-cover-loss-by-dominant-driver',
      group: 'reference-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/e9c9ad28c13f4054b59b722854fc551b?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Tree Cover Loss by Dominant Driver',
      visible: false,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'TCLDD_fuction1' },
    },
  },
  {
    type: 'FeatureLayer',
    options: {
      url: 'https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/MODIS_Thermal_v1/FeatureServer',
      id: 'modis-fire-layer',
      group: 'reference-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/7d4b378732eb4cec8f94bff7e1ca6b80?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'MODIS Fires (Last 48 Hours)',
      visible: false,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'TCLDD_fuction1' },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://utility.arcgis.com/usrsvcs/servers/9a4d7f4e22b0446f95aa9ae8d040cde5/rest/services/WorldElevation/Terrain/ImageServer',
      id: 'terrain',
      group: 'reference-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/9ed36993127f4910b533077114e54869?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Terrain',
      visible: false,
      compressionQuality: 50,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'Elevation_Tinted_Hillshade' },
    },
  },
  {
    type: 'ImageryTileLayer',
    options: {
      url: 'https://tiledimageservices.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/Esri_2020_Land_Cover_V2/ImageServer',
      id: 'landcover-10-meter',
      group: 'reference-layers',
      subgroup: null,
      portalUrl: 'https://maps.fsc.org/portal/sharing/rest/content/items/7add00974b5c44ac9f380a7206bf62e8?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Landcover 10 Meter ',
      visible: false,
      compressionQuality: 50,
      includeInDropdowns: false,
      renderingRule: { rasterFunction: 'Elevation_Tinted_Hillshade' },
      popupEnabled: true,
      popupTemplate: {
        title: '{Raster.ClassName}:',
        content: `
          <div>{Raster.desc1}</div>
          <div><i>{Raster.desc2}</i></div>
        `,
      },
    },
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://utility.arcgis.com/usrsvcs/servers/2c423a0011ed47b885af67564eb86862/rest/services/Sentinel2L2A/ImageServer',
      id: 'sentinel',
      group: 'imagery',
      subgroup: null,
      portalUrl: 'https://utility.arcgis.com/usrsvcs/servers/2c423a0011ed47b885af67564eb86862/rest/services/Sentinel2L2A/ImageServer?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Sentinel-2',
      visible: false,
      pixelType: 'u8',
      compressionQuality: 50,
      renderingRule: { rasterFunction: 'Natural Color with DRA' },
      includeInDropdowns: false,
      timeInfo: {
        startField: 'acquisitiondate',
      },
      useViewTime: false,
    },
    renderingRules: [
      'Agriculture with DRA',
      'Color Infrared with DRA',
      'Natural Color with DRA',
      'NDVI Colorized',
      'NDVI Colormap',
      'Normalized Difference Built-Up Index (NDBI)',
      'Geology with DRA',
      'Short-wave Infrared with DRA',
      'Normalized Burn Ratio',
      'NDVI - VRE only Raw',
    ],
  },
  {
    type: 'ImageryLayer',
    options: {
      url: 'https://utility.arcgis.com/usrsvcs/servers/3c96d8d1107940c682f787eeed847e93/rest/services/LandsatC2L2/ImageServer',
      id: 'landsat',
      group: 'imagery',
      subgroup: null,
      portalUrl: 'https://utility.arcgis.com/usrsvcs/servers/3c96d8d1107940c682f787eeed847e93/rest/services/LandsatC2L2/ImageServer?f=pjson', // USED TO FETCH LAYER DESCRIPTION
      title: 'Landsat 8',
      pixelType: 'u8',
      visible: false,
      compressionQuality: 50,
      renderingRule: { rasterFunction: 'Natural Color with DRA' },
      includeInDropdowns: false,
      timeInfo: {
        startField: 'acquisitiondate',
      },
      useViewTime: false,
    },
    renderingRules: [
      'Agriculture with DRA',
      'Color Infrared with DRA',
      'Geology with DRA',
      'Landsat8_TIRS1_Temperature_Celcius',
      'Natural Color with DRA',
      'Short-wave Infrared with DRA',
      'NDVI Colorized',
      'Normalized Difference Moisture Index Colorized',
      'NDVI Raw',
      'NBR Raw',
    ],
  },
];

//export const layers = process.env.REACT_APP_ENVIRONMENT === 'Production' ? prodLayers : stagingLayers;
export const layers = process.env.REACT_APP_ENVIRONMENT === 'Production' ? prodLayers : prodLayers;
